/* global window, document */
'use strict';
const $onReady = require('./lib/on-ready');
const get = require('lodash/get');
const paypal = require('public/js/components/paypal');
const paypalSmartButtons = require('./components/paypal-smart-buttons');

const {
	trackCheckoutEvent,
	trackCartRemovalEvent,
	trackClearCartEvent
} = require('public/js/lib/adobe-dtm-helper');

require('public/css/cart.scss');

const cart = {};

cart.removeItem = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);

	const confirmMessage = $link.data('confirm') || window.javascriptContent.are_you_sure_confirmation;
	const confirmation = window.confirm(confirmMessage);
	if (!confirmation) { return; }

	const data = {
		id: $link.data('id'),
		sku: $link.data('product-id'),
		catalog: $link.data('catalog')
	};

	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/cart/remove',
		data: data,
		success: (response, status/*, xhr*/) => {
			if (status === 'success') {
				// Send remove from cart tracking events
				const productDetails = cart.getProductDetailsFromCartElement($link);
				rp_app.track.track_ec_cart_event('remove', productDetails);

				if (get(window, 'digitalData.newEvent')) {
					cart.sendAdobeDTMCartRemovalEvent(productDetails);

					if (window.digitalData.cartItems) {
						window.digitalData.cartItems -= productDetails.quantity;
					}
				}
				rp_app.location.reload();
			}
		}
	});

};

cart.emptyCart = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);
	const confirmMessage = $link.data('confirm') || window.javascriptContent.are_you_sure_confirmation;
	const confirmation = window.confirm(confirmMessage);
	if (!confirmation) { return; }

	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/cart/empty',
		success: (response, status/*, xhr*/) => {
			if (status === 'success') {
				// Get all item removal links so we can get the data we need
				const $removeLinks = rp$('.remove-link .remove-item-link');
				const productsToRemove = rp$.map($removeLinks, (link) => {
					return cart.getProductDetailsFromCartElement(rp$(link));
				});
				// Track cart remove analytics events
				rp_app.track.track_ec_cart_event('remove', productsToRemove);

				if (get(window, 'digitalData.newEvent')) {
					trackClearCartEvent();
					window.digitalData.cartItems = 0;
				}
				rp_app.location.reload();
			}
		}
	});

};

cart.updateCart = function (evt) {
	evt.preventDefault();
	const $link = rp$(this);

	/* Collect update data
	.*-----------------------------------------*/
	const items = [];
	rp$('.update-cart-quantity').each(function CartQuantity_Iterator(idx, input) {
		let $input = rp$(input);
		let item = {
			id: $input.data('id'),
			sku: $input.data('product-id'),
			catalog: $input.data('catalog'),
			quantity: $input.val()
		};
		items.push(item);
	});

	/* Validate Quanity
	.*-----------------------------------------*/
	var valid = true;
	items.forEach(function CartUpdateValidation_Iterator(item) {
		let qty = parseInt(item.quantity, 10);
		if (isNaN(qty) || qty < 0) {
			valid = false;
		} else {
			item.quantity = qty;
		}
	});
	if (valid === false) {
		const invalidMessage = $link.data('invalid-update-message') || 'Invalid Quantities!';
		window.alert(invalidMessage);
		return;
	}

	/* Update Quantities
	.*-----------------------------------------*/
	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/cart/update-cart',
		data: {
			items: items
		},
		success: (response, status/*, xhr*/) => {
			if (status === 'success') {
				// If any item's quantity is set to 0, we need to count it as a cart removal for GA Enhanced Ecommerce
				const productsToRemove = [];
				rp$('.update-cart-quantity').each(function (index, input) {
					let $input = rp$(input);
					if (Number($input.val()) === 0) {
						productsToRemove.push(cart.getProductDetailsFromCartElement($input));
					}
				});
				if (productsToRemove.length > 0) {
					rp_app.track.track_ec_cart_event('remove', productsToRemove);

					if (get(window, 'digitalData.newEvent')) {
						productsToRemove.forEach((product) => {
							cart.sendAdobeDTMCartRemovalEvent(product);

							if (window.digitalData.cartItems) {
								window.digitalData.cartItems -= product.quantity;
							}
						});
					}
				}
				rp_app.location.reload();
			}
		}
	});
};

cart.getProductDetailsFromCartElement = function ($element) {
	return {
		id: $element.data('sku-stripped'),
		name: $element.data('name'),
		brand: $element.data('brand'),
		price: Number($element.data('price')) || null,
		quantity: 1,
	};
};

cart.handleKeyupQuantity = function (e) {
	const $input = rp$(this);
	const quantity = parseInt($input.val(), 10);
	const originalQuantity = parseInt($input.data('initial-quantity'), 10);
	// Using parent() to make this somewhat less rigid (as opposed to sibling() or global)
	const $updateLink = $input.parent().find('.update-cart-link');

	// Hide "update" if value is same as original or empty
	if (quantity === originalQuantity || isNaN(quantity)) {
		$updateLink.css({ 'visibility': 'hidden' });
	} else {
		$updateLink.css({ 'visibility': 'visible' });
	}

	if (e.which === 13) {
		cart.updateCart(e);
	}
};

cart.sendAdobeDTMCartRemovalEvent = function (product) {
	// Track the removal of the cart product
	const eventDetails = {
		id: String(product.id),
		name: product.name
	};

	trackCartRemovalEvent(eventDetails);
};

window.getShippingQuote = function (postalCode) {
	postalCode = postalCode || null;

	rp$(document).trigger('cartGetShippingQuotes:request');

	/* Fetch Shipping Quote
	.*-----------------------------------------*/
	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/cart/shipping-quote',
		data: {
			postalCode: postalCode
		},
		success: (response/*, status, xhr*/) => {
			rp$(document).trigger('cartGetShippingQuotes:response', response);
		},

	});
};

$onReady({
	rp$, window,
	label: 'cart',
	fn: function () {
		rp$('.cart-listing-module').on('click', '.remove-item-link', cart.removeItem);
		rp$('.cart-listing-module').on('click', '.empty-cart-link', cart.emptyCart);
		rp$('.cart-listing-module').on('click', '.update-cart-link', cart.updateCart);
		rp$('.cart-listing-module').on('keyup', '.update-cart-quantity', cart.handleKeyupQuantity);
		rp$('.cart-checkout-component').on('click', '.paypal-button', paypal.doPaypalCheckout);
		rp$('.cart-checkout-component').on('click', '.place-order-button', trackCheckoutEvent);

		const paypalContainerClass = '.paypal-smart-buttons';
		paypalSmartButtons.initSmartButtons(paypalContainerClass, {
			loadingCallback: (show) => {
				if (show) {
					rp$('body').overlaySpinner();
				} else {
					rp$('body').overlaySpinner.remove();
				}
			}
		});
	},
});
